module.exports = __webpack_public_path__ + "static/01-test-7bad256fb6794a47f6df435bc14a5e74.jpg";